import { getEmailLogsDetails } from "../../../../../actions/Utilities/EmailLogs";

import { useQuery } from "react-query";

export default function useEmailLogsDetails(activityId) {
  const res = useQuery(["GetEmailLogsDetails", activityId], () => {
    return getEmailLogsDetails(activityId);
  });
  return res;
}
